"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TabListContext: function() {
        return TabListContext;
    },
    TabListProvider: function() {
        return TabListProvider;
    },
    useTabListContext_unstable: function() {
        return useTabListContext_unstable;
    }
});
const _reactcontextselector = require("@fluentui/react-context-selector");
const tabListContextDefaultValue = {
    appearance: 'transparent',
    reserveSelectedTabSpace: true,
    selectTabOnFocus: false,
    disabled: false,
    selectedValue: undefined,
    onRegister: ()=>{
    /* noop */ },
    onUnregister: ()=>{
    /* noop */ },
    onSelect: ()=>{
    /* noop */ },
    getRegisteredTabs: ()=>{
        return {
            registeredTabs: {}
        };
    },
    size: 'medium',
    vertical: false
};
const TabListContext = (0, _reactcontextselector.createContext)(undefined);
const TabListProvider = TabListContext.Provider;
const useTabListContext_unstable = (selector)=>(0, _reactcontextselector.useContextSelector)(TabListContext, (ctx = tabListContextDefaultValue)=>selector(ctx));
